import { LoadingIndicator } from '@/lib/base/foundations/loading-indicator';

const LoadingScreen = function () {
  return (
    <div className='pg-text-centered min-h-screen flex items-center justify-center bg-bg-primary'>
      <LoadingIndicator size='lg' />
    </div>
  );
};

export default LoadingScreen;
